import React from "react";
import { Column, GroupRow, Title } from "./styles";
import SimpleField from "components/SimpleField/SimpleField";

const ManualBadgeLogs = ({ successfulAmount }) => {
  return (
    <>
      <Title>Users List</Title>
      <GroupRow>
        <Column>
          <SimpleField
            label="Number of successful users"
            value={successfulAmount}
          />
        </Column>
      </GroupRow>
    </>
  );
};

export default ManualBadgeLogs;
